export const TRANSACTION_INSTALLMENT_TYPE_DEF_GET ="/TransactionInstallmentTypeDef/GetAllTransactionInstallmentTypeDef"
